/* eslint-disable */
<template>
  <div class="app-container">
    <div v-if="!isAuthenticated">
      <router-view />
    </div>
    <div v-else class="dashboard-layout">
      <!-- Overlay para cerrar sidebar en móvil -->
      <div 
        v-if="isMobile && !isSidebarCollapsed" 
        class="sidebar-overlay"
        @click="closeSidebar"
      ></div>
      
      <SideBar 
        :class="{ 
          'sidebar-collapsed': isSidebarCollapsed,
          'sidebar-mobile-open': isMobile && !isSidebarCollapsed,
          'sidebar-mobile-closed': isMobile && isSidebarCollapsed
        }"
        @close-sidebar="closeSidebar"
      />
      
      <div class="main-content" :class="{ 
        'main-content-expanded': isSidebarCollapsed && !isMobile,
        'main-content-mobile': isMobile 
      }">
        <TopBar @toggle-sidebar="toggleSidebar" />
        <div class="content-area">
          <router-view />
        </div>
      </div>
      
      <!-- Tour Manager - Solo visible cuando el usuario está autenticado -->
      <TourManager />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SideBar from './components/layout/SideBar.vue'
import TopBar from './components/layout/TopBar.vue'
import TourManager from './components/tour/TourManager.vue'

export default {
  name: 'App',
  components: {
    SideBar,
    TopBar,
    TourManager
  },
  data() {
    return {
      isSidebarCollapsed: false,
      isMobile: false
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated'
    })
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
    },
    closeSidebar() {
      if (this.isMobile) {
        this.isSidebarCollapsed = true
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      // En móvil, empezar con sidebar cerrado
      if (this.isMobile && !this.isSidebarCollapsed) {
        this.isSidebarCollapsed = true
      }
    },
    handleResize() {
      this.checkMobile()
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f7fa;
  color: #333;
}

.app-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.dashboard-layout {
  display: flex;
  height: 100vh;
  position: relative;
}

/* Overlay para cerrar sidebar en móvil */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 250px;
  width: calc(100% - 250px);
  transition: all 0.3s ease;
}

.main-content-expanded {
  margin-left: 60px;
  width: calc(100% - 60px);
}

.main-content-mobile {
  margin-left: 0;
  width: 100vw;
  max-width: 100vw;
}

.content-area {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Ensure full width in mobile */
@media (max-width: 768px) {
  .main-content-mobile .content-area {
    width: 100vw;
    max-width: 100vw;
    padding: 15px;
    margin: 0;
    box-sizing: border-box;
  }
}

/* Cards base styles */
.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.card-header {
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
}

/* Button styles */
.btn-primary {
  background-color: #3f51b5 !important;
  border-color: #3f51b5 !important;
}

.btn-primary:hover {
  background-color: #303f9f !important;
  border-color: #303f9f !important;
}

.text-primary {
  color: #3f51b5 !important;
}

.bg-primary {
  background-color: #3f51b5 !important;
}

/* Configuraciones específicas para Vuetify overlays */
.v-overlay {
  z-index: 2000 !important;
}

.v-dialog .v-overlay {
  z-index: 2100 !important;
}

.v-menu .v-overlay {
  z-index: 2200 !important;
}

.v-tooltip .v-overlay {
  z-index: 2300 !important;
}

/* Asegurar que el tour tenga prioridad sobre Vuetify */
.guided-tour-overlay {
  z-index: 2400 !important;
}

/* Prevenir errores de scroll strategy */
.v-overlay__scrim {
  position: fixed !important;
}

/* Asegurar que los elementos del DOM estén disponibles */
html, body {
  position: relative;
}

/* Prevenir conflictos con el manejo de scroll */
body.tour-active {
  overflow: hidden !important;
}

/* Prevenir errores de classList en elementos undefined */
[data-tour] {
  position: relative;
}

/* Asegurar que los overlays de Vuetify no interfieran con el tour */
.v-overlay--active {
  z-index: 2000 !important;
}

/* Asegurar compatibilidad con diferentes navegadores */
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar-overlay {
    display: block;
  }
  
  .content-area {
    padding: 15px;
  }
  
  .card {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .card-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .content-area {
    padding: 10px;
  }
  
  .card {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  .card-title {
    font-size: 1rem;
  }
}

/* Utility classes for responsive design */
.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

@media (max-width: 768px) {
  .mobile-only {
    display: block;
  }
  
  .desktop-only {
    display: none;
  }
}

/* Responsive table utilities */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Vuetify responsive improvements */
@media (max-width: 768px) {
  /* Mejorar espaciado en móviles */
  .v-row {
    margin: 0 -8px !important;
  }
  
  .v-col {
    padding: 8px !important;
  }
  
  /* Botones más grandes en móvil */
  .v-btn {
    min-height: 40px !important;
  }
  
  .v-btn--size-small {
    min-height: 36px !important;
  }
  
  /* Cards más compactas */
  .v-card {
    border-radius: 12px !important;
  }
  
  .v-card-text {
    padding: 12px !important;
  }
  
  /* Formularios más espaciados */
  .v-text-field, .v-select {
    margin-bottom: 12px !important;
  }
  
  /* Chips más legibles */
  .v-chip {
    font-size: 0.8rem !important;
    height: 28px !important;
  }
  
  /* Títulos más pequeños */
  .v-card-title {
    font-size: 1.1rem !important;
    padding: 12px !important;
  }
  
  /* Diálogos fullscreen en móvil */
  .v-dialog {
    margin: 8px !important;
  }
  
  .v-dialog > .v-card {
    max-height: calc(100vh - 16px) !important;
  }
}

@media (max-width: 480px) {
  /* Diálogos fullscreen en pantallas muy pequeñas */
  .v-dialog {
    margin: 0 !important;
  }
  
  .v-dialog > .v-card {
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }
  
  /* Botones de acción apilados */
  .action-buttons {
    flex-direction: column !important;
    gap: 4px !important;
  }
  
  .action-buttons .v-btn {
    width: 100% !important;
    justify-content: flex-start !important;
  }
}
</style>
